export default function loadScript(path,async){
    const script = document.createElement("script")
    script.src = path
    script.async = async

    document.body.appendChild(script)
}